import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useSelectedBusiness } from "../UserAccess/useSelectedBusiness";

export interface DataSharingConnectionRequestDto {
  sourceBusinessName: string;
  sourceSiteName: string;
}

const useGetConnectionQuery = (code: string, options?: QueryOptions<DataSharingConnectionRequestDto>) => {
  const business = useSelectedBusiness();
  return useUserQuery<DataSharingConnectionRequestDto>({ path: `/api/businesses/${business.id}/dataSharing/codes/${code}` }, options);
};

export default useGetConnectionQuery;